import './Home.css'
import { Hero, Pouplars, Gaming } from '../../section/index'

const Home = () => {
  return (
    <>
      <Hero/>
      <Pouplars/>
      <Gaming/>
    </>
  )
}

export default Home
